import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const stats = [
  ["240 GSM", "cotton feel"],
  ["7-day", "easy returns"],
  ["COD", "available"],
];

const BrandStorySection = ({ image }) => (
  <section className="px-4 py-7 md:px-8 md:py-10 lg:px-12" data-testid="brand-story-section">
    <div className="grid overflow-hidden rounded-[8px] border border-white/10 bg-[#101010] md:grid-cols-[0.95fr_1.05fr]">
      <div className="relative min-h-[260px] md:min-h-[420px]">
        <img
          src={image}
          alt="Cynos premium streetwear styling"
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
          decoding="async"
          sizes="(max-width: 768px) 100vw, 48vw"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
      </div>
      <div className="flex flex-col justify-center p-5 md:p-8 lg:p-10">
        <span className="font-mono text-[10px] uppercase tracking-[0.26em] text-cynos-red md:text-xs">
          About Cynos
        </span>
        <h2 className="mt-2 font-anton text-[clamp(2rem,8vw,3rem)] uppercase leading-none md:text-5xl">
          Limited streetwear, made for daily rotation.
        </h2>
        <p className="mt-4 max-w-xl text-sm leading-6 text-zinc-400 md:text-[15px]">
          Cynos builds premium graphic and oversized tees for Indian streetwear culture: bold prints,
          reliable fits, and pieces that look sharp from college corridors to late-night plans.
        </p>
        <div className="mt-5 grid grid-cols-3 gap-2">
          {stats.map(([value, label]) => (
            <div key={value} className="rounded-[8px] border border-white/10 bg-black/35 px-3 py-4">
              <div className="font-anton text-2xl uppercase leading-none text-white md:text-3xl">{value}</div>
              <div className="mt-1 font-mono text-[9px] uppercase tracking-[0.16em] text-zinc-500">{label}</div>
            </div>
          ))}
        </div>
        <Link
          to="/why-choose-cynos"
          className="mt-6 inline-flex min-h-[46px] w-fit items-center gap-2 rounded-[8px] border border-white/15 px-5 font-mono text-[11px] uppercase tracking-[0.18em] transition hover:border-white hover:text-cynos-red"
        >
          Why Cynos <ArrowRight size={14} />
        </Link>
      </div>
    </div>
  </section>
);

export default BrandStorySection;
